export default __webpack_public_path__ + "static/media/batata_doce.92be10e9.jpg";